import { buildTgssFile } from './buildTgssFiocData';

const preLoaderActions = require('actions/preLoaderActions');
import { history } from 'routes/history';
const actionTypes = require('constants/actionTypes');
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
const { PATH_DOCUMENTATION, errorTag } = require('utilities/uTagging');
const { ERROR_EN_DOCUMENTACION, ERROR_AL_SUBIR_DOCUMENTACION } = require('constants/analyticsErrors');
const { BASE_PATH } = require('constants/index');
import { INFRA_TIMEOUT } from 'constants/errorTypes';
import { startPolling } from './polling';
import { post } from '../utilities/APIRequestHelper';
import { formatText } from 'core/i18n';
import { TGSS_RADIO_VALUES } from 'components/newAccountSteps/profileSteps/ProfileStep5/constants';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';

const STATUS_UPDATING = 'UPDATING-DOCUMENTATION';
const formActions = require('react-redux-form').actions;

const getInformationDocumentService = (dispatch, saveRequestData, callback) => {
    Api.get(apiURLBuilder.getURL('getDocumentationToUpload'), saveRequestData).then(
        data => {
            dispatch(formActions.change('userProfile.clientRisk', data.body.clientRisk));
            dispatch(formActions.change('userProfile.tgssWasChecked', data.body.tgss));
            dispatch({
                type: actionTypes.CLEAR_DOCUMENT_INFO,
            });
            dispatch({
                type: actionTypes.GET_DOCUMENT_INFO,
                data: data.body,
            });
            callback(true, data.body);
        },
        error => {
            errorTag(error.body, PATH_DOCUMENTATION, ERROR_EN_DOCUMENTACION, error.statusCode);
            dispatch(preLoaderActions.hidePreLoader2());
            history.push(`${BASE_PATH}/errors`);
        }
    );
};

const getInformationDocument = (accessToken, callback, statusDocType = 'REQUIRED') => {
    const saveRequestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
            originCountry: getReferenceCodeByCountry().toUpperCase(),
            version: 2,
        },
        query: { status: statusDocType },
    };

    return dispatch => {
        getInformationDocumentService(dispatch, saveRequestData, callback);
    };
};

const deleteFileService = dataObject => {
    const requestData = {
        header: {
            Authorization: `Bearer ${dataObject.accessToken}`,
        },
        query: {
            file: '',
            filename: dataObject.fileName,
            fileType: dataObject.fileType,
        },
    };
    Api.post(apiURLBuilder.getURL('deleteUploadedFile'), requestData);
};

const deleteFile = dataObject => {
    return () => {
        deleteFileService(dataObject);
    };
};

const handleCommonResponse = (dispatch, response, files, endRequest, isAres) => {
    if (response.status === 200) {
        if (!files[0] || !files[0]?.uploadResolvers) {
            setTimeout(() => {
                endRequest();

                dispatch(preLoaderActions.hidePreLoader());
            }, 1500);

            return;
        }
        files?.forEach(iteration => {
            const { successUpload } = iteration.uploadResolvers;
            successUpload(iteration.file);
        });
        setTimeout(() => {
            endRequest();
            !isAres && dispatch(preLoaderActions.hidePreLoader());
        }, 1500);
    } else if (response.status === 401) {
        const { unauthorizedUpload } = files[0].uploadResolvers;

        dispatch(preLoaderActions.hidePreLoader());
        unauthorizedUpload();
        errorTag('', PATH_DOCUMENTATION, ERROR_AL_SUBIR_DOCUMENTACION, response.status);
    } else {
        const { errorOnUpload } = files[0].uploadResolvers;

        dispatch(preLoaderActions.hidePreLoader());
        errorOnUpload();
        errorTag('', PATH_DOCUMENTATION, ERROR_AL_SUBIR_DOCUMENTACION, response.status);
    }
};

const handleVerification = response => {
    const { ok } = response;
    const status = (response.body !== null && response.body.status) || response.status;
    if (ok && status !== STATUS_UPDATING) {
        return false;
    }

    return true;
};

const handleFinish = (response, stats, dispatch, files, endRequest, isAres) => {
    const { ok } = stats;
    const status = (response.body !== null && response.body.status) || response.status;
    if (ok && status !== STATUS_UPDATING) {
        handleCommonResponse(dispatch, response, files, endRequest, isAres);
    } else {
        history.push(`${BASE_PATH}/errors`);
    }
};

const uploadDocumentation = (dispatch, getState, files, token, updateProgress, endRequest, isAres) => {
    dispatch(preLoaderActions.showPreLoader());
    dispatch(formActions.change('userProfile.uploadingDocuments', true));

    const finalFiles = [];
    const xhttp = new XMLHttpRequest();

    if (xhttp.upload) {
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState === 4) {
                if (xhttp.status === INFRA_TIMEOUT) {
                    dispatch(
                        startPolling({
                            asyncFetch: () => post('recoverDocumentation', {}, { version: '2' }),
                            callback: handleVerification,
                            callbackEnd: (response, stats) =>
                                handleFinish(
                                    response,
                                    stats,
                                    dispatch,
                                    files,
                                    () => {
                                        endRequest();
                                        dispatch(formActions.change('userProfile.uploadingDocuments', false));
                                    },
                                    isAres
                                ),
                            delay: 10,
                            ttl: 4,
                            retryOnFailure: false,
                        })
                    );

                    return;
                }
                handleCommonResponse(
                    dispatch,
                    xhttp,
                    files,
                    () => {
                        endRequest();
                        dispatch(formActions.change('userProfile.uploadingDocuments', false));
                    },
                    isAres
                );
            }
        };
    }

    xhttp.open('POST', apiURLBuilder.getURL('uploadDocumentationFile'), true);

    xhttp.upload.addEventListener('progress', e => {
        files.map(iteration => {
            const {
                file: { name, preview },
                uploadResolvers: { loadingFile, loadedFile },
            } = iteration;

            updateProgress(e, preview, name, { loadingFile, loadedFile });
        });
    });

    xhttp.setRequestHeader('Authorization', `Bearer ${token}`);
    xhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhttp.setRequestHeader('Accept', 'application/json;charset=UTF-8');
    xhttp.setRequestHeader('originCountry', getReferenceCodeByCountry().toUpperCase());
    xhttp.setRequestHeader('version', '2');

    const isCheckTgssActive = getState().userProfile.documentationTgssConsent === TGSS_RADIO_VALUES.CONSENT;
    const tgssConsentFile = dispatch(buildTgssFile());

    if (isCheckTgssActive && getState().documentation.get('filesToUpload').size === 1) {
        const request = {
            consent: formatText('uploads-workActivityInfoRead'),
            checkTgss: isCheckTgssActive,
            documentation: [tgssConsentFile],
        };
        xhttp.send(JSON.stringify(request));

        return;
    }

    files.map(iteration => {
        const {
            file: { name },
            docId,
        } = iteration;

        const reader = new FileReader();
        reader.readAsDataURL(iteration.file);
        reader.onload = () => {
            const formData = { filename: name, fileType: docId, file: reader.result.match(/,(.*)$/)[1] };
            finalFiles.push(formData);
        };
        reader.onloadend = () => {
            if (finalFiles.length === files.length) {
                if (isCheckTgssActive) {
                    finalFiles.push(tgssConsentFile);
                }
                const request = {
                    consent: isCheckTgssActive ? formatText('uploads-workActivityInfo') : '',
                    checkTgss: isCheckTgssActive,
                    documentation: finalFiles,
                };

                xhttp.send(JSON.stringify(request));
            }
        };
    });
};

const sendFiles = (files, token, updateProgress, endRequest, isAres) => {
    return (dispatch, getState) => {
        uploadDocumentation(dispatch, getState, files, token, updateProgress, endRequest, isAres);
    };
};

export default {
    getInformationDocument,
    deleteFile,
    sendFiles,
};
